import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Jede Woche dasselbe: Stunden für die Vorbereitung',
  description: 'Sonntag, 22 Uhr. Morgen früh steht die erste Gruppe. Und du sitzt noch immer vor einem leeren Dokument.\n\nJede Woche verbringst du wertvolle Stunden damit, Übungen zu suchen, Stundenbilder zu skizzieren, Choreografien von Grund auf neu zu entwickeln und den Unterricht für Kinder, Jugendliche und Erwachsene mit unterschiedlichen Niveaus und Zielen anzupassen. Das kostet Zeit, die du eigentlich für deine Schüler und für dich selbst brauchst.'
}, {
  emoji: '⚠️',
  title: 'Die ständigen Fragen vor jeder Stunde',
  description: 'Du fragst dich immer wieder...\n\nWas soll der Fokus der heutigen Stunde sein? Soll ich Technik, Choreografie, Rhythmus oder Ausdruck in den Vordergrund stellen? Ist die Gruppe bereit für den nächsten Schritt? Wie baue ich eine sinnvolle Progression über das gesamte Semester auf? Wie gestalte ich Stunden für eine Gruppe, in der alle auf unterschiedlichen Niveaus sind?\n\nJede Unterrichtsstunde wird zur eigenen Planungsaufgabe.'
}, {
  emoji: '📚',
  title: 'Dein Unterrichtswissen ist überall – aber nirgendwo wirklich greifbar',
  description: 'Tanzübungen. Aufwärmprogramme. Choreografie-Ideen. Rhythmik-Spiele. Bewertungsbögen. Progressionspläne. Semesterstrukturen.\n\nAlles ist vorhanden...\n\nAber es liegt verstreut in Ausbildungsunterlagen, alten Notizbüchern, YouTube-Favoriten, privaten Dokumenten und einem Wirrwarr aus Ordnern auf deinem Computer.\n\nNichts davon ist in einem einzigen, strukturierten System organisiert, das du jeden Tag mit Sicherheit und Vertrauen nutzen kannst.'
}, {
  emoji: '😩',
  title: 'Der stille Erschöpfungspunkt, den viele Tanzlehrer kennen',
  description: 'Zwischen Unterrichtsvorbereitung, Elternkommunikation, Semesterorganisation, Choreografieerstellung und dem ständigen Anpassen an unterschiedliche Gruppen und Niveaus bleibt kaum Raum für das, was wirklich zählt:\n\nPräsent und lebendig im Studio zu sein. Deinen Schülern das Tanzen wirklich beibringen zu können. Und die Arbeit zu genießen, für die du ausgebildet wurdest.'
}];
export function PainSection() {
  return <section className="bg-brand-beige px-4 py-6 sm:px-6" data-id="element-95">
      <h2 className="mb-2 text-center text-2xl font-bold leading-tight sm:text-3xl" data-id="element-96">
        KOMMT DIR DAS BEKANNT VOR?
      </h2>
      <div className="mx-auto mb-5 max-w-xl text-center text-sm font-medium leading-relaxed" data-id="element-97">
        <p data-id="element-98">
          Du liebst das Tanzen. Du liebst es, wenn deine Schüler Fortschritte
          machen, wenn eine Gruppe zusammenwächst, wenn ein Kind zum ersten Mal
          sicher über die Bühne läuft.
        </p>
        <p className="mt-2" data-id="element-99">
          Aber die Realität hinter dem Unterricht sieht oft anders aus.
        </p>
        <p className="mt-2" data-id="element-100">
          Wenn du als Tanzlehrer in einer Tanzschule, einem Verein, einer freien
          Akademie, einer Grundschule oder als selbstständiger Tanzpädagoge in
          Deutschland, Österreich oder der Schweiz arbeitest, kennst du sicher
          mindestens eine dieser Situationen:
        </p>
      </div>
      <div className="space-y-2.5" data-id="element-101">
        {pains.map(pain => <article key={pain.title} className="flex gap-3 rounded-md border-l-4 border-brand-rose bg-brand-cream p-3 shadow-sm" data-id="element-102">
            <span className="mt-0.5 text-xl" aria-hidden="true" data-id="element-103">
              {pain.emoji}
            </span>
            <div data-id="element-104">
              <h3 className="mb-1 text-[15px] font-bold uppercase leading-tight" data-id="element-105">
                {pain.title}
              </h3>
              <p className="whitespace-pre-line text-[13px] font-medium leading-relaxed text-brand-text" data-id="element-106">
                {pain.description}
              </p>
            </div>
          </article>)}
      </div>
    </section>;
}